<template>
  <div :class="['h-bg', hideBg ? 'hide-bg' : '']" :style="`background:url(${cover}) no-repeat center/cover`">
    <div class="h-container">
      <div class="h-inner">
        <div class="logo-content">
          <div class="logo-eol">
            <!-- <img src="../../assets/custom/party/index/logo-eol-r.png"> -->
            <img v-if="schoolInfo && schoolInfo.school_logo" :src="schoolInfo.school_logo" />
            <!-- <img src="http://apps-api.jiaoyu.cn/uploads/school_logo/2025/07/28/1753668600_8296.png" /> -->

          </div>
        </div>
        <div class="handle-box">
          <div :class="['eol-right-user', menuOpen ? 'up' : 'down']" @mouseleave="menuOpen = false"
            @click="menuOpen = !menuOpen">
            <div class="login-btn" v-if="!loginUserInfo || loginUserInfo.school_code != school_code"
              @click="handleLogin()">登录</div>
            <template v-else>
              <div class="mine-lines">
                <!-- <div class="user-imgs-box"></div> -->
                <span>{{ loginUserInfo && loginUserInfo.name ? loginUserInfo.name : loginUserInfo &&
                  loginUserInfo.username}}</span>
              </div>
              <ul @mouseleave="menuOpen = false" class="eol-submine-box">
                <template v-if="services.DEPLOY !== 'hzvtc'">
                  <li class="submine-items">
                    <a :href="`${services.LOGIN_SERVER}/${school_code}/worker`">信息服务中心</a>
                  </li>
                  <li class="submine-items">
                    <a :href="`${services.LOGIN_SERVER}/${school_code}/userInfo`">个人信息</a>
                  </li>
                  <li class="submine-items">
                    <a :href="`${services.LOGIN_SERVER}/${school_code}/editPassword`">修改密码</a>
                  </li>
                </template>
                <li class="submine-items" @click="logoutEvents">
                  <a href="javascript:;">退出登录</a>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import services from '../../config/services';
import { mapState, mapActions } from 'vuex';
import { Message } from "ant-design-vue"
import utils from '../../config/utils';
export default {

  data() {
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      menuData: [],
      search: false, // 是否显示搜索框
      keywords: "", // 搜索关键词
      services,
      menuOpen: false,
      cover: "",
    }
  },
  props: {
    p_search: {
      type: Boolean
    },
    content: {
      type: String
    },
    active: {
      type: String
    },
    hideBg: {
      trpe: Boolean
    }
  },
  async mounted() {
    await this.getAppsLoginUserInfo()
    this.getLoginSchoolInfo({ school_code: this.school_code }).then(res => {
      if (res.code == '0000') utils.setTitle(document.title + "-" + res.data.school_name)
    });
    // 如果访问的是杭职院党建思政育人平台,学校code不是杭职院code，强制返回登录页
    // await this.judgeSchool()
  },
  methods: {
    ...mapActions(["requestAppsLogout", 'getAppsLoginUserInfo', "getLoginSchoolInfo"]),
    // 退出登录
    logoutEvents() {
      this.requestAppsLogout()
      this.handleLogin()
    },
    // 点击登录
    handleLogin() {
      // if (window.location.href.indexOf("hzvtc/detail") > -1) {
      //   localStorage.setItem("eol-hzvtc-detail-key", this.$route.query.key)
      // }
      // window.open(`${services.LOGIN_SERVER}/${this.school_code}/login?from=${window.location.href}`, "_self")
      window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, "_self")

    },
    // 判断学校是否是杭职院code,如果不是不允许访问,带杭职院code跳转到信息服务中心
    judgeSchool() {
      if (this.school_code != services.PARTY_CODE) {
        console.log(this.school_code);
        window.open(`/center/${this.school_code}/Page404`, "_self")
      }
    },
    routerPush(row) {
      window.open(`/center${row.url}`, row.target ? row.target : "_self")
    },
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
      schoolInfo: (state) => state.appsLogin.schoolInfo,
    }),
  },
}
</script>

<style lang="less" scoped>
* {
  font-family: Microsoft YaHei;
}

.h-bg {
  width: 100%;
  // height: 522px;
  position: relative;

  // z-index: 10;
  &.hide-bg {
    height: auto;
    background: url('');
  }

  .h-container {
    width: 100%;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);

    .h-inner {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;

      img {
        max-width: 100%;
        height: auto;
      }

      .logo-content {
        display: flex;
        align-items: center;

        // margin-right: 80px;
        .split {
          width: 1px;
          height: 18px;
          background: #bdbdbd;
          margin: 0 14px;
        }

        .logo-eol {
          font-size: 0;

          img {
            width: 66px;
            height: auto;
          }
        }

        .logo-szdj {
          font-size: 0;

          img {
            width: 88px;
          }
        }
      }

      .menu-content {
        white-space: nowrap;

        .item {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          position: relative;
          cursor: pointer;
          display: inline-block;

          &:hover {
            color: #b1000e;
          }

          &.active {
            color: #b1000e;

            &::before {
              content: '';
              display: inline-block;
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              bottom: -12px;
              width: 20px;
              height: 4px;
              background: #b1000e;
              border-radius: 2px;
            }
          }

          &:not(:last-child) {
            margin-right: 24px;
          }
        }
      }

      .handle-box {
        display: flex;
        align-items: center;
        height: 100%;
        font-size: 0;

        .split {
          width: 1px;
          height: 18px;
          background: #bdbdbd;
          margin: 0 15px;
        }

        .search {
          .normal {
            width: 18px;
            height: 18px;
            background: url('../../assets/custom/party/index/search.png') no-repeat center/cover;
            cursor: pointer;
            display: inline-block;
          }

          .active {
            display: flex;
            align-items: center;
            position: relative;

            input {
              width: 180px;
              height: 34px;
              line-height: 34px;
              background: #f3f5f6;
              padding: 0 50px 0 14px;
              border: none;

              &::placeholder {
                font-size: 14px;
                color: #a6a6a6;
              }
            }

            .handle-search {
              width: 15px;
              height: 14px;
              background: url('../../assets/custom/party/index/search.png') no-repeat center/cover;
              cursor: pointer;
              right: 14px;
              top: 50%;
              transform: translateY(-50%);
              position: absolute;
            }
          }
        }

        .login-btn {
          cursor: pointer;
          font-size: 14px;
          color: #333333;
          white-space: nowrap;
          width: 48px;
          height: 24px;
          background: #c1333f;
          text-align: center;
          line-height: 24px;
          font-size: 14px;
          color: #fffcfc;
        }

        .eol-right-user {
          max-width: 260px;
          position: relative;
          height: 100%;
          display: flex;
          align-items: center;
        }

        .eol-right-user .close-page-box {
          position: absolute;
          display: inline-block;
          font-size: 16px;
          color: #3a3a3a;
          display: inline-block;
          margin-left: 5px;
          top: 13px;
          left: -80px;
          cursor: pointer;
        }

        .eol-right-user .close-page-box img {
          vertical-align: -4px;
        }

        .eol-right-user .mine-lines {
          height: 100%;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          display: flex;
          align-items: center;
        }

        .eol-right-user .mine-lines span {
          vertical-align: middle;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          max-width: 55px;
          margin: 0 8px 0 6px;
        }

        .eol-right-user .mine-lines::after {
          content: '';
          display: inline-block;
          width: 12px;
          height: 12px;
          background-image: url('../../assets/custom/party/index/menu-down.png');
          background-repeat: no-repeat;
          background-size: 100% auto;
          margin-left: 4px;
        }

        .eol-right-user.up .mine-lines::after {
          -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
          -webkit-transition: -webkit-transform 0.3s;
          transition: transform 0.3s;
        }

        .eol-right-user.down .mine-lines::after {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
          -webkit-transition: -webkit-transform 0.3s;
          transition: transform 0.3s;
        }

        // .eol-right-user .user-imgs-box {
        //   display: inline-block;
        //   width: 20px;
        //   height: 20px;
        //   margin-right: 4px;
        //   vertical-align: middle;
        //   text-align: right;
        //   background: url('../../../assets/custom/party/index/user.png')
        //     no-repeat center;
        //   background-size: 100% auto;
        // }

        .eol-right-user .eol-submine-box {
          background: #ffffff;
          border: 1px solid #dfe3e4;
          position: absolute;
          z-index: 1000;
          top: 100%;
          right: -12px;
          padding: 18px 15px 18px 20px;
          text-align: left;
          display: none;
          min-width: 130px;
        }

        .eol-right-user.up .eol-submine-box {
          display: block;
        }

        .eol-right-user.down .eol-submine-box {
          display: none;
        }

        .eol-right-user .submine-items {
          height: 30px;
          color: #71737b;
          line-height: 30px;
          font-size: 14px;
          cursor: pointer;
        }

        .eol-right-user .submine-items a {
          display: block;
          width: auto;
          color: #71737b;
        }

        .eol-right-user .submine-items.active,
        .eol-right-user .submine-items:hover a {
          color: #178586;
          text-decoration: none;
        }

        .eol-right-user .mine-left-icons {
          width: 14px;
          height: 14px;
          margin-right: 6px;
          display: inline-block;
          vertical-align: -2px;
        }
      }
    }
  }
}
</style>